module.exports = __webpack_public_path__ + "static/media/folders.1c881c1d.svg";